<template>
    <div class="bottom_box">
  <div class="top">
    <div class="wrap">
      <div class="contact">
        <h3>关于我们</h3>
        <ul>
          <li><a href="javascript:;"><i class="phone"></i>客服热线：027-51850933</a></li>
          <li><a href="javascript:;"><i class="mail"></i>kefu@ytzhihui.com</a></li>
          <li><a href="javascript:;"><i class="cooperation"></i>商务合作：027-51850968</a></li>
          <li><a href="javascript:;"><i class="address"></i>武汉市东湖新技术开发区关南三路特1号</a></li>
          <div class="clear"></div>
        </ul>
      </div>
      <!-- div class="code">
        <ul>
          <li><a href="javascript:;"><img src="/img/comQRcode/reader_app.png"/>下载手机APP</a></li>
          <li><a href="javascript:;"><img src="/img/comQRcode/qrcode_weixin.jpg"/>关注云田智慧</a></li>
        </ul>
      </div-->
    </div>
  </div>
  <div class="bottom">
        <p>Copyright 1998 - {{ year }}<label id="currentYear"></label> www.ready.ytzhihui.com .All Rights Reserved.   &nbsp;&nbsp;武汉鼎方信息技术有限公司 &nbsp;版权所有  &nbsp;&nbsp;
    	<a  target="_blank" class="icp_txt">鄂ICP备2021001795号-2</a>
        <!-- href="http://www.beian.miit.gov.cn" -->
	</p>
	<div style="text-align:center;background-color:#111;margin:0 auto;font-size:12px; padding:5px 0 3px;">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42018502002940" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../assets/images/icp.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">鄂公网安备 42018502002940号</p></a>
    </div>
  </div>
</div>
</template>

<script>

import { getUserInfo } from '@/common/utils/localStorage.js'
  export default {
    name: 'Footer',
    data() {
      return {
        threePage: {
          one: false,
          two: false,
          three: false,        
        },
        scrollTop:0,
        btnFlag:false,
        backtop: false,
        year: "",
      }
    },
    mounted(){    
        this.getNowDate()
    },
    destroyed () {
    },
    methods: {
        getNowDate() {
            const timeOne = new Date()
            this.year = timeOne.getFullYear()
            // let month = timeOne.getMonth() + 1
            // let day = timeOne.getDate()
            // month = month < 10 ? '0' + month : month
            // day = day < 10 ? '0' + day : day
            // const NOW_MONTHS_AGO = `${year}-${month}-${day}`
            // return NOW_MONTHS_AGO
        }
    }
  }
</script>

<style scoped lang="scss">
//   .backtop{
//     position: fixed;
//     right: 50px;
//     bottom: 50px;
//     background-color: #f2f5f6;
//     box-shadow: 0 0 6px rgba(0,0,0, .12);
//     text-align: center;
//     line-height: 20px;
//     padding: 8px;
//     font-size: 16px;
//     color: #999;
//     cursor: pointer;
//     span{
//       display: block;
//     }
//   }
  .backtop{
    position: fixed;
    right: 50px;
    bottom: 50px;
    z-index: 9999;
    // box-shadow: 0 0 6px rgba(0,0,0, .12);
    text-align: center;
    line-height: 20px;
    padding: 0px 8px;
    font-size: 16px;
    color: #999;
    cursor: pointer;
    >i{
        display: block;
        width:110px;
        height:110px;
        // background: url("../assets/images/0.png") center center;
        background-size: 100%;
    }
    >i.icon-arrow-up{
        width:110px;
        height:110px;
        background: url("../assets/images/02.png") center center;
        background-size: 100%;
    }
  }
  .bottomInfo {
    padding: 10px 0px;
    width: 100%;
    line-height: 30px;
    font-size: 0px;
    background-color: white;
    margin-top: 30px;
  }

  /* 1 */
  .topBottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .topBottom-left {
    color: rgba(51, 51, 51, 1);
    font-size: 12px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }

  .topBottom-left>span {
    padding: 0px 10px 0px 0px;
    cursor: pointer;
  }

  .topBottom-left>span:not(:first-child) {
    padding: 0px 10px 0px 10px;
  }

  .topBottom-left>span:not(:last-child) {
    border-right: 1px solid rgba(153, 153, 153, 1);
  }

  .topBottom-left a {
    text-decoration: none;
    color: rgba(51, 51, 51, 1);
  }

  .topBottom-right {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .topBottom-right>div {
    margin-left: 20px;
    display: flex;
    align-items: center;
    position: relative;
  }

  .tiantianImg {
    position: absolute;
    top: -100px;
    width: 80px;
  }

  .tiantianImgOne {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .topBottom-right>div>span {
    color: rgba(153, 153, 153, 1);
    font-size: 12px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }

  .bottomInfo-container {
    width: 1200px;
    margin: 0px auto;
    font-size: 14px;
  }

  .lasetDivThree {
    color: rgba(153, 153, 153, 1);
    font-size: 12px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }
  .gw-link, .gw-link a{
      font-size:12px;
    color: rgba(153, 153, 153, 1);
    margin-right:10px;
    text-decoration: none;
  }
  .gw-link a:hover{
      color:red;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue